// Portfolio data for Jiyoun Lee
export const portfolioData = {
  // Personal Information
  personal: {
    name: "이지연 Jiyoun Lee",
    englishName: "Jiyoun Lee", 
    title: "Developer",
    subtitle: "일상에 편리한 도구를 개발합니다.",
    description: "안녕하세요! 사용자의 일상을 더 편리하게 만드는 도구들을 개발하는 이지연 Jiyoun Lee입니다. 새로운 기술을 배우고 실제 문제를 해결하는 것을 좋아합니다.",
    email: "fakexorgenuine@gmail.com",
    phone: "no comment",
    location: "Seoul, Korea",
    github: "https://github.com/SnowyCommander",
    linkedin: "www.linkedin.com/in/snowycommander"
  },

  // Navigation items
  navigation: [
    { id: "home", label: "Home", href: "/", icon: "Home" },
    { 
      id: "resume", 
      label: "Resume", 
      href: "/resume", 
      icon: "AddressCardRegular",
      subItems: [
        { id: "why_me", label: "Why Me?", href: "/resume#why_me" },
        { id: "skills", label: "Skills", href: "/resume#skills" },
        { id: "experience", label: "Experience", href: "/resume#experience" },
        { id: "edu", label: "Edu", href: "/resume#edu" },
        { id: "download", label: "Download", href: "#download" }
      ]
    },
    { id: "projects", label: "Projects", href: "https://github.com/SnowyCommander", icon: "Folder", external: true },
    { id: "posts", label: "Posts", href: "https://velog.io/@snowycommander/series/PJ01", icon: "PenToSquareRegular", external: true },
    { id: "wishes", label: "Wishes", href: "https://velog.io/@snowycommander/series/Wishes", icon: "Star", external: true },
    { id: "contacts", label: "Contacts", href: "/contacts", icon: "CommentsRegular" },
    { id: "footer", label: "Footer", href: "#footer", icon: "ChevronDown" }
  ],

  // Spec/Resume (detailed data)
  resume: {
    whyMe: {
      title: "Why Me?",
      highlights: [
        "사용자 중심의 편리한 도구 개발",
        "문제 해결을 위한 창의적 접근",
        "새로운 기술 학습에 대한 열정",
        "실제 문제를 해결하는 실용적 개발"
      ]
    },
    experience: [
      {
        company: "개인 프로젝트",
        position: "풀스택 개발자",
        period: "2025.10.10 - 2025.10.12",
        description: "유튜브를 통해 외국어를 학습하는 사람들을 위한 안들리는 연음 수집기",
        tech: ["Claude Sonnet 4.5", "React", "Vercel"],
        link: "https://unheard-sounds-collector.vercel.app/"
      },
      {
        company: "프리랜서 개발자",
        position: "풀스택 개발자",
        period: "2023 - 현재",
        description: "일상 편의를 위한 웹 애플리케이션 개발"
      }
    ],
    skills: {
      frontend: ["React", "JavaScript", "CSS3", "HTML5"],
      backend: ["Node.js", "Python", "MongoDB"],
      tools: ["Git", "VS Code", "Figma"]
    },
    education: [
      {
        institution: "자기주도 학습",
        degree: "웹 개발 과정",
        period: "2022 - 2023",
        description: "온라인 강의 및 프로젝트 기반 학습"
      }
    ]
  },

  // Spec/Resume (minimal data) - 기존 호환성 유지
  specs: [
    {
      category: "Frontend",
      resume: ["React", "JavaScript", "CSS3"]
    },
    {
      category: "Backend", 
      resume: ["Node.js", "Python", "MongoDB"]
    }
  ],

  // Portfolio projects (minimal data)
  projects: [
    {
      id: 1,
      title: "할일 관리 앱",
      description: "간편한 Todo 리스트 애플리케이션",
      tech: ["React", "LocalStorage"]
    },
    {
      id: 2,
      title: "가계부 도구",
      description: "월별 지출 관리 웹앱",
      tech: ["Vue.js", "Chart.js"]
    }
  ],

  // Posts (minimal data)
  posts: [
    {
      id: 1,
      title: "React 훅 사용법",
      date: "2024-01-15",
      excerpt: "유용한 React 훅들에 대해 알아보기"
    },
    {
      id: 2,
      title: "JavaScript 팁 모음",
      date: "2024-01-10", 
      excerpt: "일상에서 자주 쓰는 JavaScript 꿀팁들"
    }
  ],

  // Wishes (minimal data)
  wishes: [
    "AI 기반 개인 비서 앱 개발",
    "오픈소스 프로젝트 기여하기",
    "개발자 커뮤니티 운영"
  ],

  // Contact info
  contact: {
    email: "jiyoun@example.com",
    availability: "새로운 프로젝트 협업에 열려있습니다"
  }
};

// UI Animation states
export const uiStates = {
  typingTexts: [
    "편리한 도구를 만듭니다",
    "사용자 경험을 개선합니다", 
    "문제를 해결합니다"
  ]
};